import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { shopifyApi } from 'services';
import type { CreateWidgetPageRequest, CreateWidgetPageResponse } from 'services/shopifyApi';

export const useShopifyConnectionStatus = () => {
  return useQuery({
    queryKey: ['shopify', 'connection-status'],
    queryFn: () => shopifyApi.getConnectionStatus(),
    retry: false,
    staleTime: 30000, // 30 seconds
  });
};

export const useCreateShopifyWidgetPage = () => {
  const queryClient = useQueryClient();

  return useMutation<CreateWidgetPageResponse, Error, CreateWidgetPageRequest>({
    mutationFn: (request: CreateWidgetPageRequest) => shopifyApi.createWidgetPage(request),
    onSuccess: () => {
      // Invalidate widget pages list to refetch
      queryClient.invalidateQueries({ queryKey: ['shopify', 'widget-pages'] });
    },
  });
};

export const useDeleteShopifyWidgetPage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (pageId: string) => shopifyApi.deleteWidgetPage({ page_id: pageId }),
    onSuccess: () => {
      // Invalidate widget pages list
      queryClient.invalidateQueries({ queryKey: ['shopify', 'widget-pages'] });
      // Invalidate installation queries to reflect the deletion and primary change
      queryClient.invalidateQueries({ queryKey: ['installations'] });
    },
  });
};

export const useListShopifyWidgetPages = () => {
  return useQuery({
    queryKey: ['shopify', 'widget-pages'],
    queryFn: () => shopifyApi.listWidgetPages(),
    retry: false,
    staleTime: 30000, // 30 seconds
  });
};
